export const enum ReverseChargeSetting {
  DISABLED = "disabled",
  FOREIGN_CUSTOMER = "foreign-customers",
  FOREIGN_CUSTOMER_WITH_IC = "foreign-customers-with-ic",
  FOREIGN_CUSTOMER_WITH_DIC = "foreign-customers-with-dic",
  FOREIGN_CUSTOMER_WITH_VALID_DIC = "foreign-customers-with-valid-dic",
}
